import { createSlice } from '@reduxjs/toolkit'
import { NotificationsSchema } from '../types/Notification'
import { fetchNotifications } from '../services/fetchNotifications'
import { fetchNotificationSubscribers } from '../services/fetchNotificationSubscribers'


const initialState: NotificationsSchema = {
	isLoading: false,
	error: '',
	notifications: [],
	subscribers: {}
}

const notificationsSlice = createSlice({
	name: 'notifications',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchNotifications.pending, (state) => {
				state.isLoading = true
				state.error = ''
			})
			.addCase(fetchNotifications.fulfilled, (state, action) => {
				state.isLoading = false
				state.notifications = action.payload
			})
			.addCase(fetchNotifications.rejected, (state, action) => {
				state.isLoading = false
				state.error = action.payload
			})
			.addCase(fetchNotificationSubscribers.fulfilled, (state, action) => {
				state.isLoading = false
				state.subscribers = { ...state.subscribers, ...(action.payload || {}) }
			})
	}
})

export const { actions: notificationsActions } = notificationsSlice
export const { reducer: notificationsReducer } = notificationsSlice
